import {combineLatest, map, Observable} from 'rxjs';

import {Injectable} from '@angular/core';
import {ApiService, IGetMessageStatus} from '@core/api/data-access';

@Injectable({
	providedIn: 'root',
})
export class CronMessageService {
	constructor(private apiService: ApiService) {}

	public getMessageStatus(...messageID: IGetMessageStatus[]): Observable<IGetMessageStatus[]> {
		if (!Array.isArray(messageID)) messageID = [messageID];

		// parallel observable requests
		const requests: Observable<IGetMessageStatus>[] = messageID.map(reqMsg => {
			return this.apiService.get<IGetMessageStatus>(`Cron/message`, {messageid: reqMsg.id});
		});

		// wait for all requests to complete
		return combineLatest(requests).pipe(
			// map the array of results into a single object
			map((results: IGetMessageStatus[]) => {
				return results.map((result, index) => {
					const reqMsg = messageID[index];
					reqMsg.status = result.status;
					return reqMsg;
				});
			}),
		);
	}
}
